/* eslint-disable parog-web/no-glint-expect-error-directive */
import { get } from '@ember/object';
import { service } from '@ember/service';
import { dasherize } from '@ember/string';
import Component from '@glimmer/component';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import type ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import type SemeiaSessionService from 'parog-web/services/session';
import Sections from './base-consult-form/sections';

interface Signature {
  Args: {
    forcComponent: ForcJournalEventBasedComponent;
  };
}

export default class MiciBaseConsultForm extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  Sections = Sections;

  get shouldShowScore(): boolean {
    return Boolean(this.session.medic);
  }

  <template>
    <Provider @forcComponent={{@forcComponent}}>
      <:content as |form|>
        {{! @glint-expect-error }}
        {{yield to='additionalInfoMessage'}}
        {{#if this.shouldShowScore}}
          <div class='ui info message visible' data-test-score-info>
            Score :
            {{changesetGet @forcComponent.changeset 'score'}}
          </div>
        {{/if}}
        <div class='field'>
          <form.Date
            @labelName='Date du questionnaire'
            @propertyName='occurredAt'
          />
        </div>
        {{! @glint-expect-error }}
        {{#each @forcComponent.sections as |section|}}
          <div class='field'>
            {{#let (get this.Sections (dasherize section)) as |Section|}}
              <Section @form={{form}} @forcComponent={{@forcComponent}} />
            {{/let}}
          </div>
        {{/each}}
      </:content>
    </Provider>
  </template>
}
